import _prop from "ramda/es/prop";
import _assoc from "ramda/es/assoc";
import _reduce from "ramda/es/reduce";
import _keys from "ramda/es/keys";
import _pipe from "ramda/es/pipe";
import _map from "ramda/es/map";
import _type from "ramda/es/type";
import _curry from "ramda/es/curry";
import round from './round';

var roundObject = _curry(function (d, obj) {
  switch (_type(obj)) {
    case 'Array':
      return _map(roundObject(d), obj);

    case 'Object':
      return _pipe(_keys, _reduce(function (acc, key) {
        return _assoc(key, roundObject(d, _prop(key, obj)), acc);
      }, {}))(obj);

    case 'Number':
      return round(d, obj);

    default:
      return obj;
  }
});

export default roundObject;